import { createSelector } from 'reselect'

import {
  getCurrentAccount,
  getCurrentUser,
  getAccountProjects
} from 'state/selectors'

export const getApplicableProjects = createSelector(
	[
		state => getCurrentAccount(state),
		state => getCurrentUser(state),
		state => getAccountProjects(state)
	],
	(accountData, userData, projects) => {
		const applicableProjects = {}

		if(!accountData){
			return applicableProjects
		}

		const adminIds = accountData.adminIds ? accountData.adminIds : []
		const pmIds = accountData.pmIds ? accountData.pmIds : []
		const guestIds = accountData.guestIds ? accountData.guestIds : []
		const myTeamIds = userData.teamIds ? userData.teamIds : []

		const amGuest = guestIds.indexOf(userData.id) !== -1
		const amAdminOrPm = adminIds.indexOf(userData.id) !== -1 || pmIds.indexOf(userData.id) !== -1

		projects.forEach(project => {
			if(!project){
				return
			}

			const teamIds = project.teamIds ? project.teamIds : []

			let shouldAdd = false

			if(!amGuest){
				if(amAdminOrPm || project.is_public){
					shouldAdd = true
				}else{
					teamIds && teamIds.some(teamId => {
						if(myTeamIds.indexOf(teamId) !== -1){
							shouldAdd = true
							return true
						}
					})
				}
			}else{
				if(project.guestIds.indexOf(userData.id) !== -1){
					shouldAdd = true
				}
			}

			if(shouldAdd){
				applicableProjects[project.id] = project
			}
		})

		return applicableProjects
	}
)

export const isTasksLoading = state => state.dashboard.userTasks.loading



// WEBPACK FOOTER //
// ./src/state/selectors/dashboardSelector.jsx